var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404 = function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 753,
    height: 401
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M753 0v401H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M302.126 135.375c26.235-45.44 84.332-61.007 129.773-34.772l2.5-4.33c-47.83-27.616-108.988-11.229-136.603 36.602zM336.9 265.147c-45.44-26.235-61.008-84.332-34.773-129.772l-4.33-2.5c-27.615 47.83-11.228 108.988 36.603 136.603z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M431.464 100.353c44.938 25.945 60.152 83.814 33.907 129.272l4.33 2.5c27.6-47.805 11.635-108.753-35.737-136.103zm33.907 129.272c-26.245 45.458-83.969 61.217-128.907 35.272l-2.5 4.33c47.372 27.35 108.137 10.703 135.737-37.102zM220 279.5V85h-5v194.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M106 229h149v-5H106zM216.55 84.44l-112.5 140.5 3.9 3.12 112.5-140.5zM106 226.5l-1.95-1.56L106 229zM513 228h149v-5H513z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m623.55 83.44-112.5 140.5 3.9 3.12 112.5-140.5zM628 279.5V85h-5v194.5zM625.5 85h2.5l-4.45-1.56z"
  })));
};
export default Svg404;